export const LookupConstants = {
  COUNTRY_US_ID: 236,
  COUNTRY_US: "United States of America",
  SEX_MALE_ID: 1,
  STATE_FLORIDA : "Florida",
}
